export default "__VITE_ASSET__c10c8f2c__"